export default __webpack_public_path__ + "assets/models/f4005e3c3d346d4b0770d64757cc5955.glb";